import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Title from "../../components/common/Title";
import { Postdata } from "../../helpers/api.service";
import HttpService from "../../helpers/httpServices";
import { message } from "../../redux/actions/toastActions";
import Loader from "../../components/common/Loader";
import Breadcrumb from "../../components/common/Breadcrumb";
import Link from "../../components/common/Link";
import "../../styles/Profile.scss";
import { Button, Form, Modal, Tab, Tabs } from "react-bootstrap";
import ModalPopup from "../../components/common/Modal";
import BoardFiles from "../../components/Board-Management/BoardFiles";
import { Topbar } from "../../components/include/Topbar";
import filterIcon from "../../assets/Icons/filter.svg";
import deleteGif from "../../assets/gifs/delete.gif";
import fileUploadGif from "../../assets/gifs/fileUpload.gif";
import { type } from "@testing-library/user-event/dist/type";
import SchoolNotes from "../../components/School-Management/SchoolNotes";
import SchoolFiles from "../../components/School-Management/SchoolFiles";
import Contributions from "../../components/School-Management/Contributions";
import { isPermission, isRole } from "../../redux/selectors/authSelector";
import Error403Page from "../ErrorPage";
import DeleteModal from "../../components/common/DeleteModal";
import dayjs from "dayjs";

const TeacherViewMember = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [matchIds, setMatchIds] = useState([]);
  const [Data, setData] = useState("");
  const [cmIds, setCMIds] = useState([]);
  const [apiloader, setapiloader] = useState(false);
  const [coinloader, setcoinloader] = useState(false);
  const [targetlink, setTargetLink] = useState({ type: "", targetLink: "" });
  const [showModal, setShowModal] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [modalData, setModalData] = useState({ platform: "", link: "" });
  const [modalFile, setmodalFile] = useState(false);
  const [modalForm, setModalForm] = useState(false);
  const [noteIdToDelete, setNoteIdToDelete] = useState(null);
  const [isloading, setIsloading] = useState(true);
  const [activeTab, setActiveTab] = useState("About");
  const [formdata, setFormdata] = useState({
    name: "",
    designation: "",
    bio: "",
    profile_img: "",
    social_media: [],
    notes: [],
    files: [],
    contribution: [],
    start_date: "",
    end_date: "",
    status: 1,
  });
  const [modalOpenDeleteSuccess, setModalOpenDeleteSuccess] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const permissions = useSelector(isPermission);
  const role = useSelector(isRole)
  console.log("permissions", permissions)
  const isAccessible = role == "schooladmin" || permissions && permissions?.includes('view_School_Management') || false;
  const addPermission = role == "schooladmin" || permissions && permissions?.includes('edit_Board_Management') || false;
  const deletePermission = role == "schooladmin" || permissions && permissions?.includes('delete_School_Management') || false;

  // const tabs = ["About", "Notes", "Files", "Contribution"];
  const tabs = [""];

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const getAddButtonLabel = () => {
    switch (activeTab) {
      case "Notes":
        return "Add Notes";
      case "Files":
        return "Upload File";
      case "Contribution":
        return "Add Contribution";
      default:
        return null;
    }
  };

  const handleAddButtonClick = () => {
    if (activeTab === "Notes") {
      navigate("/school-management/add-note", {
        state: { member_id: params.id, type: "Note" },
      });
    } else if (activeTab === "Files") {
      navigate("/school-management/add-file", {
        state: { member_id: params.id, type: "File" },
      });
    } else if (activeTab === "Contribution") {
      navigate("/school-management/add-contribution", {
        state: { member_id: params.id, type: "Contribution" },
      });
    }
  };

  const handleDelete = (id) => {
    if (id && id !== "") {
      setModalData(false);
      setIsloading(true);
      Postdata(HttpService.school_management_remove, {
        id: id,
      }).then((res) => {
        navigate("/school-management");
        dispatch(message(res.message));
      });
    }
  };

  const onAddSchool = (event) => {
    event.preventDefault();
    setLoader(true);

    Postdata(HttpService.board_management_add, formdata).then((res) => {
      if (res.status === 200) {
        navigate("/board-management");
      }
      dispatch(message(res.message));
    });
    setLoader(false);
  };
  const handleModalSave = () => {
    const updated = [...formdata.social_media];
    updated[editIndex] = modalData;
    setFormdata({ ...formdata, social_media: updated });
    setShowModal(false);
  };

  async function fetchData(id) {
    const response = await Postdata(HttpService.school_management_show, {
      id: id,
    });
    if (response.status !== 200) {
      navigate("/school-management");
    }
    console.log("response>>>>>>>>>>>>>>>", response);
    setData(response.data);
    setapiloader(false);
    setFormdata({
      id: params.id,
      name: response.data.name,
      designation: response.data.designation,
      bio: response.data.bio,
      status: response.data.status,
      social_media: response.data.social_media || [],
      start_date: response.data.start_date
        ? response.data.start_date.split("T")[0]
        : "",
      end_date: response.data.end_date
        ? response.data.end_date.split("T")[0]
        : "",
    });
     if(!response.data.end_date){
      setData({
        ...Data,
        end_date:"Ongoing"
      })
    
    }
  }

  const handleStatusChange = () => {
    setLoader(true);

    Postdata(HttpService.school_management_status, { id: formdata.id, status: formdata.status }).then((res) => {
      if (res.status === 200) {
        setRefresh(!refresh);

      }
      dispatch(message(res.message));
      setLoader(false);
    });
  }

  useEffect(() => {
    if (params.id) {
      fetchData(params.id);
    }
  }, [refresh]);

  useEffect(() => {
    console.log("location.state?.currentTab", location.state?.currentTab);
    // 🟨 Set activeTab from navigation state (if exists)
    if (location.state?.currentTab) {
      setActiveTab(location.state.currentTab);
    }
  }, [location.state?.currentTab]);

  if (!isAccessible) {
    return <Error403Page />
  }
  if (loader) {
    return <Loader isClass="loader_fullscreen" />
  }


  return (
    <>
      {/* <ModalPopup
        show={modalChangeProfile}
        size="sm"
        onHide={() => setmodalChangeProfile(false)}
        heading="Change Users Profile Pictures."
      >
        <div>
          <span>Do you really wants to change users Profile Picture?</span>
        </div>
        <form onSubmit={onAddSchool}>
          <Form.Group className="form-group">
            <Form.Label>
              Profile Photo
              {!formdata.id && <span style={{ color: "red" }}>*</span>}
            </Form.Label>
            <Form.Control
              type="file"
              accept=".jpg,.png,.jpeg,.gif"
              required={!formdata.id}
              onChange={handleImagePreview}
            />
            <small>Photo need to be 1029 X 452 pixels.</small>
            {logo && (
              <>
                <img className="preview" src={logo} style={{ width: "auto" }} />
              </>
            )}
            <div className="mt-2 d-flex justify-content-center">
              <button
                className="btn btn-primary"
                type="submit"
                disabled={coinloader}
              >
                {coinloader ? "Please wait..." : "yes"}
              </button>
              <button
                className="btn btn-primary"
                onClick={() => setmodalChangeProfile(false)}
              >
                No
              </button>
            </div>
          </Form.Group>
        </form>
      </ModalPopup> */}

      {/* <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Social Media</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Platform</Form.Label>
            <Form.Control
              type="text"
              value={modalData.platform}
              onChange={(e) =>
                setModalData({ ...modalData, platform: e.target.value })
              }
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Link</Form.Label>
            <Form.Control
              type="text"
              value={modalData.link}
              onChange={(e) =>
                setModalData({ ...modalData, link: e.target.value })
              }
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleModalSave}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal> */}

      {/* <ModalPopup
        className="alert-box-popup"
        show={modalFile}
        size="lg"
        onHide={() => {
          setmodalFile(false);
          setNoteIdToDelete(null);
        }}
        onExited={() => setNoteIdToDelete(null)}
      >
        <h3>Upload File</h3>
        <div className="flex w-full justify-center py-2">
          <div className="text-center flex justify-center flex-col items-center gap-3 px-3 w-[50%]">
            <img src={fileUploadGif} className="w-[120px] " alt="del" />
            <p className="text-card-body mb-0">
              Drag and Drop File
              <p className="mb-0">or</p>
            </p>
            <div className="w-full flex justify-center gap-3 mb-2">
              <button
                className="bg-secondary_main w-fit text-white px-4 py-2 rounded-lg whitespace-nowrap"
                onClick={() => {
                  
                }}
              >
                Browse
              </button>
            </div>
          </div>
          <div className="flex flex-col text-start  gap-3 px-3 w-[50%]">
            <div>
              <label className="block mb-1 font-medium text-gray-700">
                Title <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="subject"
                placeholder="Enter Subject Name"
                className="input-field bg-[#EEF0F2]"
                // value={formData.memberName}
                // onChange={handleInputChange}
              />
              {errors.memberName && (
              <span className="text-red-500 text-sm">Required</span>
            )}
            </div>
            <div>
              <label className="block mb-1 font-medium text-gray-700">
                Description <span className="text-red-500">*</span>
              </label>
              <textarea
                name="description"
                placeholder="Write here"
                className="input-field-grey"
                // value={formData.description}
                // onChange={handleInputChange}
              />
              {errors.description && (
                <span className="text-red-500 text-sm">Required</span>
              )}
            </div>
            <div className="text-center">
              <button
                // onClick={handleSubmit}
                className="button-field-primary"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </ModalPopup> */}

      <ModalPopup
        className="alert-box-popup"
        show={modalForm}
        size="md"
        onHide={() => {
          setModalForm(false);
          setNoteIdToDelete(null);
        }}
        onExited={() => setNoteIdToDelete(null)}
      >
        {/* <i className="mdi mdi-information-outline"></i> */}
        <div className="text-center flex justify-center flex-col items-center gap-3 px-3 ">
          <h3>Delete Member</h3>
          <img src={deleteGif} className="w-[120px] " alt="del" />
          <p className="text-card-body">
            Are you sure you want to delete this member? It will erase all his
            data permanently.
          </p>
          <div className="w-full flex justify-between gap-3 mb-2">
            <button
              className="bg-secondary_main w-full text-white px-4 py-2 rounded-lg whitespace-nowrap"
              onClick={() => {
                handleDelete(noteIdToDelete);
                setModalForm(false);
              }}
            >
              Yes, Delete
            </button>
            <button
              className="button-field-primary"
              onClick={() => setModalForm(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </ModalPopup>

      <Title name="Board Management - View" />
      <Topbar title="" />
      <div className="p-6 space-y-6 pr-0">
        {/* Tabs */}
        <div className="flex justify-between flex-wrap gap-y-2">
          <div className="flex gap-2 overflow-x-auto">
            {tabs?.map((tab) => (
              <button
                key={tab}
                className={`px-4 py-2 rounded-lg whitespace-nowrap ${activeTab === tab
                  ? "bg-secondary_main text-white"
                  : "bg-white text-black"
                  }`}
                onClick={() => handleTabClick(tab)}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Conditional Buttons (not shown on "About") */}
          {activeTab !== "About" && (
            <div className="flex gap-2">
              <button
                className="bg-primary_main text-white px-4 py-2 rounded-lg whitespace-nowrap"
                onClick={handleAddButtonClick}
              >
                {getAddButtonLabel()}
              </button>
              <div className="bg-white text-black px-[15px] rounded-lg whitespace-nowrap flex items-center cursor-pointer">
                <img src={filterIcon} alt="Filter" />
              </div>
            </div>
          )}
        </div>

        {/* Conditional Tab Content */}

        {activeTab === "About" && (
          <>
            <div className="bg-white rounded p-6 ">
              <div className="flex justify-between">
                <div className="flex gap-3">
                  <div className="flex flex-col items-center justify-center w-24 h-24 rounded-full border-1 border-gray-500 cursor-pointer overflow-hidden">
                    <img
                      src={Data?.profile_img}
                      alt="Preview"
                      className="w-full h-full object-cover rounded-full"
                    />
                  </div>
                  <div>
                    <h3 className="font-semibold text-[20px] mb-2 text-gray-800">
                      {Data?.name}
                    </h3>
                    <p className="text-[16px] text-gray-800 mb-2">
                      {Data?.designation}
                    </p>
                    <p className="text-[16px] text-gray-500">
                       {dayjs(Data?.start_date).format("DD MMM YYYY")} - {Data?.end_date!=="Ongoing" ? dayjs(Data?.end_date).format("DD MMM YYYY"): Data?.end_date}
                    </p>
                  </div>
                </div>
                {addPermission ? <button
                  role="switch"
                  aria-checked={Data.status == 1 ? true : false}
                  onClick={() => handleStatusChange(Data.id)}
                  className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${Data.status ? 'bg-green-500' : 'bg-gray-300'
                    }`}
                >
                  <span
                    className={`inline-block h-[18px] w-[18px] transform rounded-full bg-white transition-transform ${Data.status ? 'translate-x-6' : 'translate-x-[3px]'
                      }`}
                  />
                </button> :
                  <h3 className="text-sm">{Data.status == 1 ? "🟢" : "🔴"}</h3>
                }
              </div>
              <div className="mt-4">
                <h3 className="font-semibold text-card-role mb-2 text-gray-800">
                  Bio:
                </h3>
                <p className="text-[15px] text-gray-800 mb-2">{Data?.bio}</p>
              </div>

              <div className="mt-4">
                <h3 className="font-semibold text-card-role mb-2 text-gray-800">
                  Professional Summary:
                </h3>
                <p className="text-[15px] text-gray-800 mb-2">
                  {Data?.description}
                </p>
              </div>
              <div className="mt-4">
                <h3 className="font-semibold text-card-role mb-2 text-gray-800">
                  Social Media:
                </h3>
                {console.log(Data, "---------")}
                {Data?.social_media &&
                  Data?.social_media.map((link, index) => (
                    <div key={index} className="">
                      <a
                        href={link}
                        target="_blank"
                        rel="noreferrer"
                        className="text-blue-600 underline text-sm truncate max-w-[80%]"
                      >
                        {link}
                      </a>
                    </div>
                  ))}
              </div>

              {deletePermission && <p
                className="text-[15px] text-secondary_main font-medium underline mb-2 mt-3 cursor-pointer w-fit "
                onClick={() => {
                  setNoteIdToDelete(Data._id);
                  setModalForm(true);
                }}
              >
                Delete Member?
              </p>}
            </div>
            {addPermission && <div className="flex justify-center">
              <button
                className="button-field-primary"
                onClick={() =>
                  navigate(
                    `/school-management/edit-member/${params.id || Data._id}`,
                    {
                      state: { type: "edit" },
                    }
                  )
                }
              >
                Edit Member
              </button>
            </div>}
            <DeleteModal
              title="Delete School Member"
              message="Are you sure you want to delete School Member?
It will erase all the data permanently."
              modalOpenDelete={modalForm}
              setmodalOpenDelete={setModalForm}
              handleDelete={handleDelete} // Don't call it here
              selectedId={noteIdToDelete}
              setSelectedId={setNoteIdToDelete}
              modalOpenDeleteSuccess={modalOpenDeleteSuccess}
              setModalOpenDeleteSuccess={setModalOpenDeleteSuccess}
              redirectPage={"School Management"}
              redirectUrl={"/school-management"}
              module={"School Member"}
            />
          </>
        )}

        {activeTab === "Notes" && (
          <>
            <SchoolNotes boardMemberId={params.id} />
          </>
        )}

        {activeTab === "Files" && (
          <>
            <SchoolFiles boardMemberId={params.id} />
          </>
        )}

        {activeTab === "Contribution" && (
          <>
            <Contributions boardMemberId={params.id} />
          </>
        )}
      </div>
    </>
  );
};

export default TeacherViewMember;
